/**
 * @generated SignedSource<<afcb6627e6ec9e07f55a16ca4393dada>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarSoldItems_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_item" | "PdpSharedSimilarSoldItemsColumns_item" | "PdpSharedSimilarSoldItemsHeader_item" | "useShouldShowSimilarSoldItems_item">;
  readonly " $fragmentType": "PdpRespSimilarSoldItems_item";
};
export type PdpRespSimilarSoldItems_item$key = {
  readonly " $data"?: PdpRespSimilarSoldItems_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarSoldItems_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarSoldItems_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSimilarSoldItemsHeader_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSimilarSoldItemsColumns_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "5226d48458f02b50c6ee3f952cb45306";

export default node;
